"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var server_1 = require("react-dom/server");
var ShouldComponentUpdate_1 = require("../../../utils/ShouldComponentUpdate");
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.baseOptions = {
            useHTML: true
        };
        return _this;
    }
    Tooltip.prototype.getData = function (current) {
        current.tooltip = this.getOptions();
        return current;
    };
    Tooltip.prototype.render = function () {
        return null;
    };
    Tooltip.prototype.shouldComponentUpdate = function (nextProps) {
        return ShouldComponentUpdate_1.shouldComponentUpdate(this.props, nextProps);
    };
    Tooltip.prototype.componentDidUpdate = function () {
        this.props.onUpdate();
    };
    Tooltip.prototype.getOptions = function () {
        var options = Object.assign(this.baseOptions, {});
        var self = this;
        if (this.props.shared) {
            options.shared = true;
            options.formatter = function () {
                return self.getSharedTooltipContent(this);
            };
        }
        else {
            options.formatter = function () {
                return self.getTooltipContent(this);
            };
        }
        return options;
    };
    Tooltip.prototype.getTooltipContent = function (data) {
        var content = data;
        var _a = this.props, labelPostfix = _a.labelPostfix, labelPrefix = _a.labelPrefix, renderContent = _a.renderContent;
        if (content && content.point && content.point.value) {
            content.value = this.getTooltipValue(content.point.value);
        }
        else {
            content.value = this.getTooltipValue(content.y);
        }
        content.label = labelPrefix || '';
        content.label += content.series.name;
        if (labelPostfix) {
            content.label += labelPostfix;
        }
        if (renderContent) {
            return server_1.renderToString(React.createElement("div", { className: "tooltip-content" }, renderContent(content)));
        }
        else {
            return server_1.renderToString(React.createElement("div", { className: "tooltip-content" },
                React.createElement("div", { className: "tooltip-value" }, content.value),
                React.createElement("div", { className: "tooltip-name" },
                    React.createElement("span", { className: "label-color", style: { background: content.color } }),
                    content.label)));
        }
    };
    Tooltip.prototype.getTooltipValue = function (val) {
        var _a = this.props, decimalPlaces = _a.decimalPlaces, valuePostfix = _a.valuePostfix, valuePrefix = _a.valuePrefix;
        var contentValue = valuePrefix || '';
        if (decimalPlaces) {
            contentValue += Number(Math.round(parseFloat(val + ("e" + decimalPlaces))) + 'e-' + decimalPlaces);
        }
        else {
            contentValue += val;
        }
        if (valuePostfix) {
            contentValue += valuePostfix;
        }
        return contentValue;
    };
    Tooltip.prototype.getSharedTooltipContent = function (data) {
        var content = data;
        var _a = this.props, renderSharedContent = _a.renderSharedContent, valuePostfix = _a.valuePostfix, valuePrefix = _a.valuePrefix;
        if (renderSharedContent) {
            return server_1.renderToString(React.createElement("div", { className: "tooltip-content shared-content" }, renderSharedContent(content)));
        }
        else {
            return server_1.renderToString(React.createElement("div", { className: "tooltip-content shared-content" }, content.points.map(function (point) {
                point.value = valuePrefix || '';
                point.value += point.y;
                if (valuePostfix) {
                    point.value += valuePostfix;
                }
                return (React.createElement("div", { className: "tooltip-value", key: point.key },
                    React.createElement("span", { className: "label-color", style: { background: point.color } }),
                    point.value));
            })));
        }
    };
    Tooltip.defaultProps = {};
    return Tooltip;
}(react_1.Component));
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map